/// <amd-module name="VSSUI/Components/InfoIcon/index" />
export * from "./InfoIcon";
